import React from 'react'
import { Workstream } from '../Plan'
import { AppContext } from '@/App';
import { DownloadIcon } from '@/Components/ui/Icons/TooltipIcon';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/Components/ui/dialog';
import ExportWBSPDF from './ExportWBSPDF';
import { PDFViewer } from '@react-pdf/renderer';

type WorkBreakdownStructureProps = {
    workstreams: Workstream[];
};

function WorkBreakdownStructure({ workstreams }: WorkBreakdownStructureProps) {
    const app = React.useContext(AppContext);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogTitle, setDialogTitle] = React.useState("");
    const [dialogContent, setDialogContent] = React.useState<React.ReactNode>(null);

    function openWBSPDFExport() {
        setDialogTitle("Export Work Breakdown Structure to PDF");
        setDialogContent(
            <PDFViewer style={{ width: "100%", height: "100%" }}>
                <ExportWBSPDF workstreams={workstreams} title={app.selectedProject?.name!} />
            </PDFViewer>);
        setDialogOpen(true);
    }

    return (
        <div>
            <div className="flex flex-row items-center justify-between mb-4">
                <h2 className="text-2xl font-bold mb-4">Work Breakdown Structure</h2>
                <button
                    className='flex flex-row w-min h-8 ml-auto items-center bg-black text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-gray-700'
                    onClick={() => openWBSPDFExport()}
                >
                    <DownloadIcon tooltip="Export WBS to PDF" className="h-4 w-4 mr-2" />
                    <span className="flex items-center h-full">{/* Ensures vertical centering */}
                        Export
                    </span>
                </button>
            </div>
            <div className="flex flex-col">
                <div className="flex flex-row w-full">
                    <div className="flex w-min mx-auto rounded-lg text-planbuilder-workstream-header-foreground bg-planbuilder-project-header p-4 shadow-sm">
                        <h1 className='text-3xl font-bold text-nowrap'>{app.selectedProject?.name}</h1>
                    </div>

                </div>
                {GetBranches(1, workstreams.length)}
                <div className='flex flex-row w-full'>
                    {workstreams.map((workstream) => (
                        <div
                            className="flex flex-col"
                            key={workstream.id}
                            style={{
                                width: `${100 / (workstreams.length)}%`,
                            }}
                        >
                            <div key={workstream.id}
                                className="flex w-min mx-auto rounded-lg text-planbuilder-workstream-header-foreground bg-planbuilder-workstream-header p-4 shadow-sm"
                            >
                                <h3 className="text-xl font-semibold">{workstream.name}</h3>
                            </div>
                            {GetBranches(1, workstream.workPackages.length)}
                            <div className="flex flex-row w-full">
                                {workstream.workPackages.map((workPackage) => (
                                    <div
                                        className="flex flex-col"
                                        style={{
                                            width: `${100 / (workstream.workPackages.length)}%`,
                                        }}
                                        key={workPackage.id}
                                    >
                                        <div className="flex w-min mx-auto rounded-lg text-planbuilder-workstream-header-foreground bg-planbuilder-workpackage-header p-4 shadow-sm">
                                            <h4 className="text-lg font-semibold my-auto">{workPackage.name}</h4>
                                        </div>
                                        {/* {GetBranches(1, 1)}
                                        <div className="flex flex-row w-full">
                                            <div
                                                className="flex flex-col mx-auto"
                                                
                                                key={workPackage.id + "-tasks"}
                                            >
                                                <ul
                                                    className="flex flex-col w-min mx-auto rounded-lg text-planbuilder-workstream-header-foreground bg-planbuilder-task p-4 shadow-lg"
                                                    role="listbox"
                                                    aria-label="Tasks"
                                                >
                                                    {workPackage.tasks.map((task) => (
                                                        <li
                                                            key={task.id}
                                                            className="text-md font-medium px-2 py-2"
                                                            style={{
                                                                borderBottom: task !== workPackage.tasks[workPackage.tasks.length - 1]
                                                                    ? '1px solid #e5e7eb'
                                                                    : undefined,
                                                            }}
                                                            role="option"
                                                        >
                                                            {task.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div> */}
                                    </div>
                                ))}
                            </div>

                        </div>
                    ))}
                </div>

            </div>
            <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
                <DialogContent
                    className="flex flex-col min-w-fit"
                    style={
                        dialogTitle === "Export Work Breakdown Structure to PDF"
                            ? { minWidth: "80vw", minHeight: "80vh", width: "80vw", height: "80vh", maxWidth: "90vw", maxHeight: "90vh" }
                            : undefined
                    }
                >
                    <DialogHeader>
                        <DialogTitle>{dialogTitle}</DialogTitle>
                    </DialogHeader>
                    {dialogContent}
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default WorkBreakdownStructure

export function GetBranches(input: number, output: number) {
    const lineLength = 25; // Length of the vertical line in pixels
    return (
        <>
            <div className='flex flex-row border-r-2 border-gray-300 mx-auto'>
                {Array.from({ length: input + 1 }).map((_, idx) => (
                    <div
                        key={idx}
                        className={'flex flex-col'}
                        style={{
                            width: `${100 / (input + 1)}%`,
                            height: `${lineLength}px`,
                        }}
                    ></div>
                ))}
            </div>
            <div className='flex flex-row'>
                {output > 1 ? Array.from({ length: output * 2 }).map((_, idx) => (
                    <div
                        key={idx}
                        className={"flex flex-col "
                            + (idx % 2 === 0 ? "border-r-2 " : "")
                            + ((idx !== 0 && idx !== (output * 2) - 1) && " border-t-2")
                            //+ (idx === output ? " border-r-2 " : "")
                            + " border-gray-300 mx-auto"}
                        style={{
                            width: `${100 / (output + 1)}%`,
                            height: `${lineLength}px`,
                        }}
                    ></div>
                ))
                    :
                    <div className='flex flex-row border-r-2 border-gray-300 mx-auto'>
                        <div
                            className={'flex flex-col w-[50%]'}
                            style={{
                                width: `50%`,
                                height: `${lineLength}px`,
                            }}
                        ></div>
                    </div>
                }
            </div>
        </>
    );
}